import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[60vh] w-full flex-col items-center justify-center px-4 py-20 text-center">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-emotion-sad-line text-4xl" />
      </span>
      <h1 className="mt-6 font-heading text-3xl font-bold text-foreground-950">404</h1>
      <p className="mt-2 text-sm text-foreground-500">
        页面不存在：<span className="text-foreground-800">{location.pathname}</span>
      </p>
      <p className="mt-4 text-sm text-foreground-600">
        你访问的页面可能已被移除，试试回到首页继续浏览。
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
      >
        <i className="ri-home-4-line" />
        返回首页
      </Link>
    </div>
  );
}